import React, {Component} from 'react';
import {connect} from 'react-redux';
import PropTypes from 'prop-types';

import {Button, Card, Form, Input, notification} from 'antd';

import {getDescriptionFromError} from "../utils/errors";
import {getTaxGroup, updateTaxGroup} from "./actions";
import {formItemLayout} from "../utils/style";
import {decodeParams} from "../utils/params";

const FormItem = Form.Item;
const ButtonGroup = Button.Group;

function hasErrors(fieldsError) {
  return Object.keys(fieldsError).some(field => fieldsError[field]);
}

class UpdateTaxGroupForm extends Component {
  componentDidMount() {
    this._load();
  }

  componentDidUpdate(prevProps) {
    if (this.props.match.params.taxGroupId !== prevProps.match.params.taxGroupId) {
      this._load();
    }
  }

  _load = () => {
    const {taxGroupId} = decodeParams(this.props.match.params);
    if (taxGroupId) {
      this.props.getTaxGroup({taxGroupId});
    }
  };

  goBack = () => {
    this.props.history.goBack();
  };

  handleSubmit = (e) => {
    const {taxGroupId} = decodeParams(this.props.match.params);
    e.preventDefault();
    this.props.form.validateFields(async(err, values) => {
      if (err) return;
      try {
        await this.props.updateTaxGroup({...values, taxGroupId});
        this.goBack();
      } catch (err) {
        notification.error({
          message: 'Failed',
          description: getDescriptionFromError(err)
        });
      }
    });
  };

  render() {
    const {form: {getFieldDecorator, getFieldsError}, loading, taxGroup} = this.props;
    const {name} = taxGroup;
    return (
      <Card title="Update Tax Group">
        <Form onSubmit={this.handleSubmit}>
          <FormItem
            {...formItemLayout}
            label="Name"
          >
            {getFieldDecorator('name', {
              initialValue: name,
              rules: [{
                required: true,
                message: 'Name is required'
              }]
            })(
              <Input />
            )}
          </FormItem>
          <FormItem>
            <ButtonGroup>
              <Button
                type="primary"
                htmlType="submit"
                disabled={loading || hasErrors(getFieldsError())}
              >
                Update Tax Group
              </Button>
              <Button
                htmlType="button"
                onClick={this.goBack}
              >
                Cancel
              </Button>
            </ButtonGroup>
          </FormItem>
        </Form>
      </Card>
    );
  }
}

UpdateTaxGroupForm.propTypes = {
  form: PropTypes.object.isRequired,
  history: PropTypes.object.isRequired,
  match: PropTypes.object.isRequired,
  getTaxGroup: PropTypes.func.isRequired,
  taxGroup: PropTypes.object.isRequired,
  updateTaxGroup: PropTypes.func.isRequired,
  loading: PropTypes.bool.isRequired,
};

const UpdateTaxGroupPage = Form.create()(UpdateTaxGroupForm);

const mapStateToProps = state => ({
  taxGroup: state.tax.taxGroup || {},
  loading: state.tax.gettingTaxGroup || state.tax.updatingTaxGroup,
});

const mapDispatchToProps = dispatch => ({
  getTaxGroup: payload => (dispatch(getTaxGroup(payload))),
  updateTaxGroup: payload => (dispatch(updateTaxGroup(payload)))
});

export default connect(mapStateToProps, mapDispatchToProps)(UpdateTaxGroupPage);



// WEBPACK FOOTER //
// ./src/Tax/UpdateTaxGroupPage.js